<template>
  <div style="margin-top: 86px">
<!--    <div class="service-top">-->
<!--      <div class="service-top-title">-->
<!--        Customer Training-->
<!--      </div>-->
<!--      <div class="service-top-title2">-->
<!--        Service Solutions-->
<!--      </div>-->
<!--      <div class="service-top-content">-->
<!--        U Vigor provides comprehensive training courses to make sure customers or veterinarians can fully understand the product features and skillfully perform operations.-->
<!--      </div>-->
<!--      <div class="service-top-content">-->
<!--        Our employees work globally to offer both onsite and online instructions to distributors, veterinaries, ranches, farms, universities. A good communication is believed to build a solid bridge of confidence and friendship.-->
<!--      </div>-->
<!--    </div>-->
    <div class="service-second">
      <div class="service-title">
        Customer Training
      </div>
      <div class="service-content">
        <p>
          U Vigor provides comprehensive training courses to make sure customers or veterinarians can fully understand the product features and skillfully perform operations.
        </p>
        <p>
          Our employees work globally to offer both onsite and online instructions to distributors, veterinaries, ranches, farms, universities.
        </p>
        <p>
          A good communication is believed to build a solid bridge of confidence and friendship.
        </p>
      </div>
    </div>
    <div class="service-third">
      <div class="service-title">
        Quality Insurance
      </div>
      <div class="service-content">
        <p>
          U Vigor attaches great importance to quality management.
        </p>
        <p>
          All instruments will be guaranteed in a significant warranty period from 2-5 years.
        </p>
        <p>
          The engineers will penetrate all end users to improve the experiences of our product.
        </p>
        <p>
          All issues can be freely communicated with us through email service@uvigorhealth.com
        </p>
      </div>
    </div>
    <div class="service-fourth">
      <div class="service-title">
        Academics & Charity
      </div>
      <div class="service-content">
        <p>
          U Vigor is determined to support educational activities.
        </p>
        <p>
          All tiny efforts will bring about a better and healthier world.
        </p>
        <p>
          We welcome all members to join to make some difference.
        </p>
        <p>
          It is our responsibility to benefit the world through various aspects.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {

  name: 'Service',
  data() {
    return {

    }
  }
}
</script>

<style src="../../assets/css/Service.css" scoped>


</style>
